import { STORE_ORDER_STATUS_OBJ, isStoreOrderAllowedStatusChange } from "@lib/types/storeOrderStatus";
import { ref } from "vue";
import { toast } from "@/ui-plus/sonner";
import { checkNewOrders } from "./playAudio";
import { cachedStoreOrders } from "./RecentOrdersStore";
import { storeOrdersApiClient } from "@api-client/store_orders";

export let isCancellingOrder = ref(false);

export const handleCancel = async (storeOrderId: string, storeId: string) => {
    if (isCancellingOrder.value) {
        return;
    }
    isCancellingOrder.value = true;
    const order = cachedStoreOrders.value[storeOrderId];
    // 🚨Every month 2% of your orders can be cancelled free🚨 after that we may still charge you for the service fees.
    // ${order.paymentMethodJSON?.isOnline ? '\n🚨THIS ORDER HAS ONLINE PAYMENT🚨\n🚨It will be refunded to customer🚨\n' : ''}

    if (!confirm(`Are you sure you want to cancel this order?

If this order was paid online, the customer will be refunded.

🚨This action cannot be undone🚨`)) {
        isCancellingOrder.value = false;
        return;
    }

    // Implement cancel logic
    const { error, data } = await (await storeOrdersApiClient[":storeId"].cancel_order.$post({
        param: { storeId },
        json: { storeOrderId }
    })).json();
    setTimeout(() => {
        checkNewOrders();
    }, 1000);
    if (error) {
        toast.error(error.message ?? "Error cancelling order");
    } else {
        toast.message(`Order cancelled ${order.paymentMethodJSON?.isOnline ? 'and refunded!' : ''}`);
        isStoreOrderAllowedStatusChange(cachedStoreOrders.value[storeOrderId].orderStatus, STORE_ORDER_STATUS_OBJ.CANCELLED);
        cachedStoreOrders.value[storeOrderId].orderStatus = STORE_ORDER_STATUS_OBJ.CANCELLED;
        // Update the timestamp to prevent the periodic refresh from reloading this order
        cachedStoreOrders.value[storeOrderId].updated_at_ts = Date.now();
        checkNewOrders();

        setTimeout(() => {
            if (data?.isTest) {
                // impossible to detect test orders in auto print app
                // but keep the logic to remind
                toast.message(`System assumes this is a test order since the order was placed and cancelled by the same user. Fees added back to your store balance`);
            } else {
                if (data?.isFeeRefunded) {
                    toast.message(`Cancelled with no fee. Fees added back to your store balance, use cancellation wisely, only 5% of orders can be cancelled free`);
                } else {
                    toast.message(`${data?.cancelPercentage}% of orders were cancelled in the last 30 days, fees not refunded! (up to 5% of orders can be cancelled free)`);
                }
            }
        }, 1000);
    }
    isCancellingOrder.value = false;
}
